import HeatmapAdaptor from './HeatmapAdaptor';

export default HeatmapAdaptor;
